<template>
  <div :class="{'rtlStyle': isRtl}">
    <transition name="fade">
      <div
        :key="'options_dark'"
        class="pu_dark"
        v-if="$store.getters.currentProduct"
        v-show="$store.getters.modal.options"
      ></div>
    </transition>
    <transition name="slide">
      <div
        v-if="$store.getters.currentProduct"
        v-show="$store.getters.modal.options"
        :key="'options'"
        :class="{'pu_tovar_img_main': this.basketPhoto && $store.getters.currentProduct.images.length > 0}"
        class="pu_bottom popup_click_hide"
      >
        <div class="pu_bottom_scroll">
          <div
            @click="close()"
            class="pu_b_close"
          ></div>
          <div
            ref="scrollContainer"
            :class="{'full-height':this.$store.getters.container === this.$store.getters.const.CONTAINER_IFRAME}"
            class="pu_bottom_inner scroll_y"
          >
            <div class="pu_tovar">
              <div
                v-if="this.basketPhoto && displayImage"
                class="pu_tovar_img"
                ref="productImage"
              >
                <template v-if="modifierImage">
                  <div
                    :style="{ paddingTop: placeholderPadding }"
                    class="placeholder"
                  >
                    <img
                      :src="modifierImage"
                      style="object-fit: cover; height: 100%;"
                      alt=""
                      class="placeholded-image "
                      width="100%"
                    />
                  </div>
                </template>
                <template v-else>
                  <template v-if="$store.getters.currentProduct.images.length > 1 && $store.getters.modal.options">
                    <slick
                      :options="slickOptions"
                      class="product-slider"
                      ref="slick"
                    >
                      <div
                        v-for="(image, index_image) in $store.getters.currentProduct.images"
                        :key="index_image"
                      >
                        <div
                          :style="{ paddingTop: placeholderPadding }"
                          class="placeholder multiple-images"
                        >
                          <img
                            :src="getImageUrl(image, IMAGE_TYPE_LARGE)"
                            alt=""
                            class="placeholded-image"
                            width="100%"
                          />
                        </div>
                      </div>
                    </slick>
                  </template>

                  <template v-else>
                    <div
                      :style="{ paddingTop: placeholderPadding }"
                      class="placeholder"
                    >
                      <img
                        :src="getImageUrl($store.getters.currentProduct.images[0], IMAGE_TYPE_LARGE)"
                        alt=""
                        class="placeholded-image"
                        width="100%"
                      />
                    </div>
                  </template>
                </template>

              </div>
              <div class="pu_tovar_description">
                <div class="pu_tovar_name">
                  {{ $store.getters.currentProduct.name }}
                  <span v-if="!$store.getters.currentProduct.showcase_price && !$store.getters.currentProduct.showcase_qty">
                    {{ $store.getters.currentProduct.qty }}&nbsp;{{ $store.getters.currentProduct.qty_unit }}
                  </span>
                  <span
                      v-if="$store.getters.currentProduct.showcase_price || $store.getters.currentProduct.showcase_qty"
                      :class="{ 'ios-font': $store.getters.checkIos }"
                  >
                    {{ $options.filters.toCurrency(+$store.getters.currentProduct.showcase_price) }},&nbsp;{{ $store.getters.currentProduct.showcase_qty }}
                  </span>
                </div>
                <div
                    class="pu_tovar_text"
                    v-html="renderDescription($store.getters.currentProduct.description)"
                ></div>
                <form v-if="$store.getters.currentProduct.modifiers.length">
                  <ul class="pu_tovar_list">
                    <li
                        v-for="(category, index) in getCategories()"
                        :key="'modifier_category_' + index"
                        :id="'modifier_category_' + category.id"
                    >
                      <template v-if="!category.is_radio_type">
                        <div class="pu_tl_head">
                          <div class="pu_tl_title">
                            {{ category.name }}
                            <i v-if="category.data.is_required"><img
                                :src="require('@/assets/img/facebook/inf_ico.svg')"></i>
                            <span
                                v-if="hasRule(category)"
                                class="pu_rule_msg"
                            >{{ getRuleMessage(category) }}</span>
                          </div>
                          <div class="pu_tl_head_info">
                            <span v-if="isNeeded(category)">{{ text('product_options_necessary') }}</span>
                            <span v-if="inSelectedRule(category)">{{ getSelectedRuleMessage(category) }}</span>
                            <span v-if="showClearModifiersButton(category)"><img
                                @click="clearModifiers(category)"
                                :class="{'pu_tl_head_info-basket_minus': !isRtl, 'rtl-pu_tl_head_info-basket_minus': isRtl}"
                                :src="require('@/assets/img/facebook/basket_minus.svg')"
                            ></span>
                          </div>
                        </div>
                        <div
                            class="pu_tl_inner"
                            v-if="!category.is_radio_type"
                        >
                          <div class="modifier" v-for="(modifier, index) in getModifiers(category)"
                               :key="'cat_' + category.id + '_mod_' + index">
                            <!-- **** {{modifier}} -->
                            <div
                                v-if="(true || modifier.categoryNew.total_qty_modifier_to !== 0) && isPicked('checkbox', modifier)"
                                class="modifier-countable modifier-range">
                            <span class="pu_tl_name">
                              <!-- minus  -->
                              <div v-if="getModifierCount(modifier.id) > 1" @click="removeModifier(modifier)"
                                   class="changeCountBox">
                                <svg width="10" height="3" viewBox="0 0 10 3" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                  <line x1="9" y1="1.40005" x2="1" y2="1.40005" stroke="#0084FF" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </div>

                              <div v-else-if="getModifierCount(modifier.id) === 1"
                                   @click="unpickCheck(modifier)"
                                   class="changeCountBox remove">
                                <svg width="10" height="3" viewBox="0 0 10 3" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                  <line x1="9" y1="1.40005" x2="1" y2="1.40005" stroke="#0084FF" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </div>

                              x&nbsp;{{ getModifierCount(modifier.id) }}
                              <!-- plus  -->


                              <div
                                  v-if="getModifierCount(modifier.id) < getMaxQntModifier(modifier, category)"
                                  @click="setModifierCount(modifier.id, getModifierCount(modifier.id) + 1)"
                                  class="changeCountBox increment">
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                  <line x1="5" y1="1" x2="5" y2="9" stroke="#0084FF" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"/>
                                  <line x1="9" y1="5" x2="1" y2="5" stroke="#0084FF" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </div>

                              <span
                                  v-else
                                  class="modifier-name-divider"
                              ></span>

                              {{ modifier.name }}
                            </span>

                              <template v-if="modifier.categoryNew.show_price">
                                <template v-if="isFreeModifier(modifier)">
                                <span
                                    v-if="!modifier.categoryNew.show_absolute_price"
                                    :class="{ 'ios-font': $store.getters.checkIos }"
                                    class="nowrap"
                                >
                                  + {{ 0 | toCurrency | replace("-", "") }}
                                </span>
                                  <span
                                      v-else
                                      :class="{ 'ios-font': $store.getters.checkIos }"
                                      class="nowrap"
                                  >
                                  {{ 0 | toCurrency }}
                                </span>
                                </template>
                                <template v-else>
                                <span
                                    v-if="!modifier.categoryNew.show_absolute_price"
                                    :class="{ 'ios-font': $store.getters.checkIos }"
                                    class="nowrap"
                                >
                                  <template v-if="modifier.display_price < 0"
                                  >-</template
                                  >
                                  <template v-else>+</template>
                                  {{
                                    modifier.display_price
                                        | toCurrency
                                        | replace("-", "")
                                  }}
                                </span>
                                  <span
                                      v-else
                                      :class="{ 'ios-font': $store.getters.checkIos }"
                                      class="nowrap"
                                  >
                                  {{ modifier.display_price | toCurrency }}
                                </span>
                                </template>
                              </template>
                            </div>
                            <label
                                v-else
                                @click.prevent="pick('checkbox', modifier)"
                                :id="'cat_' + category.id + '_mod_' + modifier.id"
                                class="pu_radio pu_check"
                                :class="{
                              pu_plus: category.data.max_qty_modifier > 1,
                              __pu_radio_disable: disabledElements.includes(
                                modifier.id
                              ),
                              pu_radio_disable: getMaxTotalModifier(modifier, category) <= 0,
                              pu_plus_gray: blockedCategories.includes(
                                modifier.category_id
                              ),
                            }"
                            >
                              <input
                                  :checked="isPicked('checkbox', modifier)"
                                  type="checkbox"
                                  :value="modifier.name"
                              />
                              <span class="pu_tl_name"
                              >{{ modifier.name }}
                              <i
                                  v-if="
                                  modifier.categoryNew.max_qty_modifier > 1 &&
                                  getModifierCount(modifier.id) > 0
                                "
                                  class="pu_cnt"
                              >
                                {{ getModifierCount(modifier.id) }}
                              </i>
                            </span>

                              <template v-if="modifier.categoryNew.show_price">
                                <template v-if="isFreeModifier(modifier)">
                                <span
                                    v-if="!modifier.categoryNew.show_absolute_price"
                                    :class="{ 'ios-font': $store.getters.checkIos }"
                                >
                                  + {{ 0 | toCurrency | replace("-", "") }}
                                </span>
                                  <span
                                      v-else
                                      :class="{ 'ios-font': $store.getters.checkIos }"
                                  >
                                  {{ 0 | toCurrency }}
                                </span>
                                </template>
                                <template v-else>
                                <span
                                    v-if="!modifier.categoryNew.show_absolute_price"
                                    :class="{ 'ios-font': $store.getters.checkIos }"
                                >
                                  <template v-if="modifier.display_price < 0"
                                  >-</template
                                  >
                                  <template v-else>+</template>
                                  {{
                                    modifier.display_price
                                        | toCurrency
                                        | replace("-", "")
                                  }}
                                </span>
                                  <span
                                      v-else
                                      :class="{ 'ios-font': $store.getters.checkIos }"
                                  >
                                  {{ modifier.display_price | toCurrency }}
                                </span>
                                </template>
                              </template>
                            </label>
                          </div>
                          <!-- <label
                            v-for="(modifier, index) in getModifiers(category)"
                            @click.prevent="pick('checkbox', modifier)"
                            :id="'cat_' + category.id + '_mod_' + modifier.id"
                            :key="'cat_' + category.id + '_mod_' + index"
                            class="pu_radio pu_check"
                            :class="{'pu_plus': category.data.max_qty_modifier > 1, 'pu_radio_disable': disabledElements.includes(modifier.id), 'pu_plus_gray': blockedCategories.includes(modifier.category_id)}"
                          >
                            <input
                              :checked="isPicked('checkbox', modifier)"
                              type="checkbox"
                              :value="modifier.name"
                            >
                            <span class="pu_tl_name">{{modifier.name}}
                              <i
                                v-if="modifier.categoryNew.max_qty_modifier > 1 && getModifierCount(modifier.id) > 0"
                                class="pu_cnt"
                              >
                                {{ getModifierCount(modifier.id) }}
                              </i>
                            </span>
                            <template v-if="modifier.categoryNew.show_price">
                              <template v-if="isFreeModifier(modifier)">
                                <span v-if="!modifier.categoryNew.show_absolute_price">
                                  + {{0 | toCurrency | replace('-', '')}}
                                </span>
                                <span v-else>
                                  {{0 | toCurrency}}
                                </span>
                              </template>
                              <template v-else>
                                <span v-if="!modifier.categoryNew.show_absolute_price">
                                  <template v-if="modifier.display_price < 0">-</template>
                                  <template v-else>+</template>
                                  {{modifier.display_price | toCurrency | replace('-', '')}}
                                </span>
                                <span v-else>
                                  {{modifier.display_price | toCurrency}}
                                </span>
                              </template>
                            </template>
                          </label> -->
                        </div>
                      </template>

                      <template v-else>

                        <template v-if="category.data.is_compact_view">
                          <div class="pu_tl_head">
                            <div class="pu_tl_title">
                              {{ category.name }}
                              <i v-if="category.data.is_required"><img
                                  :src="require('@/assets/img/facebook/inf_ico.svg')"></i>
                              <span
                                  v-if="hasRule(category)"
                                  class="pu_rule_msg"
                              >{{ getRuleMessage(category) }}</span>
                            </div>
                            <div class="pu_tl_head_info">
                              <span v-if="isNeeded(category)">{{ text('product_options_necessary') }}</span>
                              <span v-if="inSelectedRule(category)">{{ getSelectedRuleMessage(category) }}</span>
                              <span v-if="showClearModifiersButton(category)"><img
                                  @click="clearModifiers(category)"
                                  :class="{'pu_tl_head_info-basket_minus': !isRtl, 'rtl-pu_tl_head_info-basket_minus': isRtl}"
                                  :src="require('@/assets/img/facebook/basket_minus.svg')"
                              ></span>
                            </div>
                          </div>
                          <div class="pu_tl_inner">
                            <div
                                @click="openCompactSelector(category)"
                                class="select_block"
                            >
                              <div class="sb_info">
                                <div class="sb_select">
                                  <template v-if="infoSelectModifier(category)">
                                    <template>
                                <span>{{
                                    infoSelectModifier(category).name
                                  }}</span>
                                    </template>
                                  </template>
                                  <template v-else>
                                    <template> {{ text('choice_select_modifier') }}</template>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>

                        <RadioBubbleModifiers
                            v-if="category.data.style === 'babl' && !category.data.is_compact_view"
                            :category="category"
                            :show-rule="hasRule(category)"
                            :is-needed="isNeeded(category)"
                            :in-rule="inSelectedRule(category)"
                            :selected-rule-message="getSelectedRuleMessage(category)"
                            :is-picked="isPicked"
                            :pick="pick"
                            :get-modifier-count="getModifierCount"
                        />

                        <RadioCardModifiers
                            v-if="category.data.style === 'photo' && !category.data.is_compact_view"
                            :category="category"
                            :show-rule="hasRule(category)"
                            :is-needed="isNeeded(category)"
                            :in-rule="inSelectedRule(category)"
                            :selected-rule-message="getSelectedRuleMessage(category)"
                            :is-picked="isPicked"
                            :pick="pick"
                            :get-modifier-count="getModifierCount"
                        />

                        <template v-if="category.data.style === 'radio' && !category.data.is_compact_view">
                          <div class="pu_tl_head">
                            <div class="pu_tl_title">
                              {{ category.name }}
                              <i v-if="category.data.is_required"><img
                                  :src="require('@/assets/img/facebook/inf_ico.svg')"></i>
                              <span
                                  v-if="hasRule(category)"
                                  class="pu_rule_msg"
                              >{{ getRuleMessage(category) }}</span>
                            </div>
                            <div class="pu_tl_head_info">
                              <span v-if="isNeeded(category)">{{ text('product_options_necessary') }}</span>
                              <span v-if="inSelectedRule(category)">{{ getSelectedRuleMessage(category) }}</span>
                              <span v-if="showClearModifiersButton(category)"><img
                                  @click="clearModifiers(category)"
                                  :class="{'pu_tl_head_info-basket_minus': !isRtl, 'rtl-pu_tl_head_info-basket_minus': isRtl}"
                                  :src="require('@/assets/img/facebook/basket_minus.svg')"
                              ></span>
                            </div>
                          </div>
                          <div class="pu_tl_inner">
                            <label
                                v-for="(modifier, index) in getModifiers(category)"
                                @click.prevent="pick('radio', modifier)"
                                :key="'cat_' + category.id + '_mod_' + index"
                                class="pu_radio"
                            >
                              <input
                                  :checked="isPicked('radio', modifier)"
                                  type="radio"
                                  :name="'modifier_' + category.id + '_' + modifier.id"
                                  :value="modifier.name"
                              >
                              <span class="pu_tl_name">{{ modifier.name }} <i
                                  v-if="modifier.weight && $store.getters.currentProduct.qty_unit">{{ modifier.weight }} </i></span>
                              <template v-if="modifier.categoryNew.show_price">
                              <span v-if="!modifier.categoryNew.show_absolute_price">
                                <template v-if="modifier.display_price < 0">-</template>
                                <template v-else>+</template>
                                {{ modifier.display_price | toCurrency | replace('-', '') }}
                              </span>
                                <span v-else>
                                {{ modifier.display_price | toCurrency }}
                              </span>
                              </template>
                            </label>
                          </div>
                        </template>
                      </template>

                    </li>
                  </ul>
                </form>
              </div>
            </div>
            <div class="pu_tovar_nav">
              <span
                v-if="$store.getters.currentProduct.enable_selection_qty"
                class="plus-minus"
              >
                <template v-if="$store.getters.currentProduct.is_weight_product">
                  <input
                    type="number"
                    name="count"
                    v-model="weight"
                    @input="changeWeightCount"
                    :placeholder="`Кол-во ${$store.getters.currentProduct.qty_unit || '' }`"
                  >
                </template>
                <template v-else>
                  <input type="text" name="count" :value="count">
                  <a class="cart__count-down" @click="changeCount(-1)">
                    <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1C12 1.55228 11.5523 2 11 2H1C0.447715 2 0 1.55228 0 1Z"
                        fill="#1A1A1B"/>
                    </svg>
                  </a>
                  <a
                    :class="disableChangeCount"
                    class="cart__count-up"
                    @click="changeCount(1)"
                  >
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M6 0C5.44772 0 5 0.447715 5 1V5H1C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7H5V11C5 11.5523 5.44772 12 6 12C6.55228 12 7 11.5523 7 11V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H7V1C7 0.447715 6.55228 0 6 0Z"
                            fill="#1A1A1B"/>
                    </svg>
                  </a>
                </template>
              </span>
              <div
                :class="{
                 'pu_tovar_nav_btn_none': (this.count === 0 || this.$store.getters.currentProduct.is_weight_product && this.weight === '' || this.weight === 0) && this.$store.getters.currentProduct.enable_selection_qty,
                 'pu_tovar_nav_selection_qty': !this.$store.getters.currentProduct.enable_selection_qty && this.alreadySelected
                }"
                class="pu_tovar_nav_btn"
              >
                <template v-if="!this.$store.getters.currentProduct.enable_selection_qty && this.alreadySelected">
                  <a
                    @click="addToBasketSelectionQty('delete')"
                    class="fbb_btn selection_btn selection_btn__delete"
                  >
                    {{text('product_remove')}}
                  </a>
                  <a
                    @click="addToBasketSelectionQty('save')"
                    class="fbb_btn selection_btn selection_btn__save"
                  >
                    {{text('product_save')}}<i v-html="$options.filters.toCurrency(countPrice)" :class="{'ios-font': $store.getters.checkIos}"></i>
                  </a>
                </template>
                <template v-else>
                  <a
                    @click="addToBasket"
                    :class="{'btn_loading': $store.getters.loading.addToBasket || $store.getters.loading.updateBasket}"
                    class="fbb_btn"
                  >
                    {{ button }}<i v-html="$options.filters.toCurrency(countPrice)" :class="{'ios-font': $store.getters.checkIos}"></i>
                  </a>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <CompactSelector :setModalValue="'options'"/>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  const marked = require('marked')
  import Slick from 'vue-slick'
  import '@/assets/css/slick.css'
  import {ADD_TO_BASKET, UPDATE_BASKET} from '@/store/actions.type'
  import {
    SET_MODAL,
    SET_OPEN_LIST_MODIFIRE,
    SET_SELECTED_MODIFIRE,
    SET_CURRENT_PRODUCT,
    SET_DELIVERY_SERVICES
  } from '@/store/mutations.type'
  import RadioCardModifiers from '@/components/ECommerce/Modifiers/RadioCardModifiers'
  import RadioBubbleModifiers from '@/components/ECommerce/Modifiers/RadioBubbleModifiers'
  import CompactSelector from '@/components/Default/Modals/CompactSelector'
  const renderer = {
    code(code, infostring, escaped) {
      return '<p>' + code + '</p>'
    }
  }
  marked.use({renderer})
  export default {
    name: 'Options',
    components: {
      Slick,
      RadioBubbleModifiers,
      RadioCardModifiers,
      CompactSelector
    },
    data() {
      return {
        weight: '',
        pickedModifiers: [],
        checkedModifiers: [],
        checkedModifiersId: [],
        selectedModifiers: [],
        count: 1,
        loaded: false,
        alreadySelected: false,
        needToSelect: [],
        selectRules: [],
        disabledElements: [],
        blockedCategories: [],
        modifiersCount: [],
        categoryModifiersCount: [],
        newSentCheckedModifiers: [],
        modifierImage: null,
        isAddSelectionQty: false,
        rules: {
          default: [],
          conditions: [],
          current: []
        },
        slickOptions: {
          autoplay: false,
          dots: true,
          infinite: false,
          speed: 300,
          edgeFriction: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: 0,
          adaptiveHeight: true,
          variableWidth: false,
          arrows: false,
          fade: false,
          rtl: false
        },
        IMAGE_TYPE_ORIGINAL: 0,
        IMAGE_TYPE_SPLASH: 1,
        IMAGE_TYPE_SPLASH_2X: 2,
        IMAGE_TYPE_LARGE: 3,
        unsubscribe: undefined
      }
    },
    created() {
      if (this.$store.getters.guardCssDirection === 'rtl') {
        this.slickOptions.rtl = true
      }
    },
    mounted() {
      this.loadCurrentProduct()
      this.loadModifiersRules()
      this.$store.subscribe((mutation) => {
        if (
          mutation.type === SET_MODAL &&
          mutation.payload.modal === 'options' &&
          !this.$store.getters.getSelectedModifire
        ) {
          if (mutation.payload.status === true) {
            this.alreadySelected = false
            this.loaded = false
            this.count = 1
            this.weight = ''
            this.selectRules = []
            this.needToSelect = []
            this.disabledElements = []
            this.blockedCategories = []
            this.checkedModifiers = []
            this.pickedModifiers = []
            this.selectedModifiers = []
            this.modifiersCount = []
            this.categoryModifiersCount = []
            this.newSentCheckedModifiers = []
            this.checkedModifiersId = []
            this.modifierImage = null
            this.loadCurrentProduct()
            this.loadModifiersRules()
          } else {
            if (this.$refs.scrollContainer) {
              this.$refs.scrollContainer.scrollTo(0, 0)
            }
          }
        }
      })
    },
    methods: {
      getMaxQntModifier(modifier, category) {
        const cnt = this.getModifiers(category)
            .filter(m => m.id !== modifier.id)
            .reduce((acc, m) => acc + this.getModifierCount(m.id), 0)
        const maxTotal = modifier.categoryNew.total_qty_modifier_to ? modifier.categoryNew.total_qty_modifier_to - cnt : 100
        const maxItem = modifier.categoryNew.max_qty_modifier ? modifier.categoryNew.max_qty_modifier : 100
        return Math.min(maxTotal, maxItem)
      },
      getMaxTotalModifier(modifier, category) {
        const cnt = this.getModifiers(category)
            .filter(m => m.id !== modifier.id)
            .reduce((acc, m) => acc + this.getModifierCount(m.id), 0)
        return modifier.categoryNew.total_qty_modifier_to ? modifier.categoryNew.total_qty_modifier_to - cnt : 100
      },
      infoSelectModifier(category) {
        const modifier = this.selectedModifiers.find(
          (x) => x.category_id === category.id
        )
        if (modifier) {
          return modifier
        }
        return false
      },
      openCompactSelector(category) {
        if (this.unsubscribe) {
          this.unsubscribe()
        }
        const selectedModifier = this.selectedModifiers.find(
          (x) => x.category_id === category.id
        )
        this.$store.commit(SET_MODAL, {modal: 'options', status: false})
        this.$store.commit(SET_MODAL, {modal: 'compactSelector', status: true})
        this.$store.commit(SET_OPEN_LIST_MODIFIRE, {
          category: {id: category.id, name: category.name},
          selectedModifier:
            selectedModifier === undefined ? null : selectedModifier,
          modifiers: this.getModifiers(category)
        })
        this.unsubscribe = this.$store.subscribe((mutation) => {
          if (mutation.type === SET_SELECTED_MODIFIRE) {
            if (mutation.payload && mutation.payload.id) {
              let element = mutation.payload
              const indexSelectedModifier = this.selectedModifiers.findIndex(
                (x) => x.category_id === element.category_id
              )
              if (element) {
                if (indexSelectedModifier != -1) {
                  this.selectedModifiers.splice(indexSelectedModifier, 1, element)
                } else {
                  this.selectedModifiers.push(element)
                }
              }
            }
          }
        })
      },
      updateImage(image) {
        this.modifierImage = image
      },
      renderDescription(description) {
        let sku = ''
        if (this.$store.getters.currentProduct.sku) {
          sku =
            '<span class="sku">' +
            this.$store.getters.currentProduct.sku +
            '</span>'
        }
        return marked(this.$options.filters.nl2br(description)) + sku
      },
      loadCurrentProduct() {
        if (this.loaded) {
          return
        }
        let currentProduct = this.$store.getters.currentProduct
        let selectedProducts = this.$store.getters.selectedProducts
        let sentModifiers = []
        if (this.$store.getters.currentProduct && this.$store.getters.currentProduct.sentModifiersNew) {
          currentProduct.sentModifiersNew.forEach(el => {
            sentModifiers.push(parseInt(el.id))
          })
        }
        if (!currentProduct) {
          return
        }
        let currentSentModifiers = []
        sentModifiers.forEach(id => {
          currentProduct.modifiers.forEach(el => {
            if (id === el.id &&
              !el.is_radio_type &&
              !el.categoryNew.is_compact_view &&
              el.selected === 1) {
              currentSentModifiers.push(id)
            }
          })
        })
        currentProduct.modifiers.forEach((element) => {
          if (element.count != null) {
            // element.count = 0
            this.modifiersCount.push({
              modifier_id: element.id,
              count: element.count,
              enable_max_modifiers_qty: element.categoryNew.enable_max_modifiers ? element.categoryNew.enable_max_modifiers_qty : 0,
              category_id: element.category_id,
              category_count: 0
            })
          }
        })
        // FIND DEFAULT MODIFIERS (radio_type)
        if (currentProduct.modifiers) {
          //if product is not already in basket
          if (this.addNew || selectedProducts.every((selected) => {
            return currentProduct.basket_item_id !== selected.basket_item_id
          })) {
            let defaultModifiers = {}
            // lets define default options
            currentProduct.modifiers.forEach((element) => {
              // we do this only for radio options
              if (element.is_radio_type === 1) {
                if (!defaultModifiers.hasOwnProperty(element.category)) {
                  defaultModifiers[element.category] = []
                }
                if (defaultModifiers[element.category].length === 0 && element.is_default === 1) {
                  defaultModifiers[element.category].push(element)
                }
              }
            })
            // filled every defaultModifiers[element.category] with elements which has "is_default" param == 1
            // push found default options in data.pickedModifiers
            for (let category in defaultModifiers) {
              if (defaultModifiers[category].length !== 0) {
                this.pickedModifiers.push(defaultModifiers[category][0])
                if (defaultModifiers[category][0].image) {
                  this.modifierImage = defaultModifiers[category][0].image
                }
              }
            }
          }
        }
        if (!this.addNew) {
          // FIND SELECTED MODIFIERS
          for (let i = 0; i < selectedProducts.length; i++) {
            const product = selectedProducts[i]
            if (product.basket_item_id === currentProduct.basket_item_id) {
              this.count = product.count
              this.weight = product.count
              this.alreadySelected = true
              product.modifiers.forEach((element) => {
                // Селект
                if (
                  element.categoryNew.is_compact_view &&
                  element.selected === 1
                ) {
                  this.selectedModifiers.push(element)
                }
                // Чекбоксы
                else if (
                  !element.is_radio_type &&
                  !element.categoryNew.is_compact_view &&
                  element.selected === 1
                ) {
                  this.checkedModifiers.push(element)
                  if (element.count != null) {
                    this.setModifier(element.id, element.count)
                  }
                }
                // Радио кнопки
                if (
                  element.is_radio_type &&
                  !element.categoryNew.is_compact_view &&
                  element.selected === 1
                ) {
                  this.pickedModifiers.push(element)
                  if (element.image) {
                    this.modifierImage = element.image
                  }
                }
              })
              currentSentModifiers.forEach(el => {
                this.setModifierCount(el)
              })
              this.loaded = true
            }
          }
        }
      },
      loadModifiersRules() {
        let currentProduct = this.$store.getters.currentProduct
        if (!currentProduct) {
          return
        }
        let rules = []
        let conditions = []
        let categories = this.getCategories()
        categories.forEach((category) => {
          if (!category.is_radio_type) {
            let min = null
            let max = null
            let maxForModifier = category.data.max_qty_modifier
            if (category.data.total_qty_modifier) {
              min = category.data.total_qty_modifier_from
              max = category.data.total_qty_modifier_to
            }
            let rule = {
              category_id: category.id,
              min: min,
              max: max,
              maxForModifier: maxForModifier
            }
            rules.push(rule)
            category.conditions.forEach((condition) => {
              let conditionRule = {
                if: {
                  modifier_id: condition.modifier_id,
                  category_id: condition.modifier_category_id
                },
                category_id: category.id,
                min: condition.total_qty_form,
                max: condition.total_qty_to
              }
              conditions.push(conditionRule)
            })
          }
        })
        this.$set(this.rules, 'default', rules)
        this.$set(this.rules, 'current', rules)
        this.$set(this.rules, 'conditions', conditions)
        this.updateCurrentRulesAccordingConditions()
        this.updateModifiersAccordingToRules()
      },
      addToBasketSelectionQty(option) {
        this.isAddSelectionQty = option === 'delete'
        this.addToBasket()
      },
      async addToBasket() {
        if (((this.count === 0 && this.addNew) || (this.$store.getters.currentProduct.is_weight_product && this.weight === '' && this.addNew) || (this.weight === 0 && this.addNew)) && this.$store.getters.currentProduct.enable_selection_qty) {
          this.close()
          return
        }
        const currentProduct = this.$store.getters.currentProduct
        let modifiersArray = []
        let categories = this.getCategories()
        this.needToSelect = []
        if (this.count !== 0 || this.$store.getters.currentProduct.is_weight_product && this.weight !== '') {
          categories.forEach((category) => {
            if (category.data.is_required) {
              let hasSelected = false
              if (category.is_radio_type && !category.data.is_compact_view) {
                this.pickedModifiers.forEach((modifier) => {
                  if (modifier.category_id === category.id) {
                    hasSelected = true
                  }
                })
                if (!hasSelected) {
                  this.needToSelect.push(category)
                }
              } else if (category.data.is_compact_view) {
                this.selectedModifiers.forEach((modifier) => {
                  if (modifier.category_id === category.id) {
                    hasSelected = true
                  }
                })
                if (!hasSelected) {
                  this.needToSelect.push(category)
                }
              } else {
                this.checkedModifiers.forEach((modifier) => {
                  if (modifier.category_id === category.id) {
                    hasSelected = true
                  }
                })
                if (!hasSelected) {
                  this.needToSelect.push(category)
                }
              }
            }
          })
          let stop = false
          if (this.needToSelect.length !== 0) {
            this.scrollToNeedToSelect()
            stop = true
          }
          if (this.selectRules.length !== 0) {
            this.selectRules.forEach((el) => {
              el.show = true
            })
            if (!stop) {
              this.scrollToSelectRules()
            }
            stop = true
          }
          if (stop) {
            return
          }
        }
        this.pickedModifiers.forEach((element) => {
          modifiersArray.push(element.id)
        })
        this.selectedModifiers.forEach((element) => {
          modifiersArray.push(element.id)
        })
        this.checkedModifiersId.forEach((element) => {
          modifiersArray.push(element)
        })
        const modifiers = modifiersArray.join(',')
        const modifiersNew = this.newSentCheckedModifiers
        let currentCount
        if (this.$store.getters.currentProduct.is_weight_product && this.$store.getters.currentProduct.enable_selection_qty) {
          currentCount = this.weight
        } else if (!this.$store.getters.currentProduct.enable_selection_qty && this.alreadySelected && this.isAddSelectionQty) {
          currentCount = 0
        } else {
          currentCount = this.count
        }
        let payload = {
          basketItemId: currentProduct.basket_item_id,
          productId: currentProduct.id,
          count: currentCount,
          modifiers: modifiers,
          modifiers_new: modifiersNew
        }
        if (this.addNew) {
          await this.$store.dispatch(ADD_TO_BASKET, payload)
        } else {
          await this.$store.dispatch(UPDATE_BASKET, payload)
        }
        this.close()
        if (this.count === 0 || this.$store.getters.currentProduct.is_weight_product && this.weight === '' || this.weight === 0) {
          this.count = 1
          this.weight = ''
        }
      },
      close() {
        this.$store.commit(SET_MODAL, {modal: 'options', status: false})
        this.$store.commit(SET_SELECTED_MODIFIRE, null)
      },
      scrollToNeedToSelect() {
        let element = document.querySelector(
          '#modifier_category_' + this.needToSelect[0].id
        )
        if (element) {
          element.scrollIntoView({behavior: 'smooth'})
        }
      },
      scrollToSelectRules() {
        let element = document.querySelector(
          '#modifier_category_' + this.selectRules[0].category_id
        )
        if (element) {
          element.scrollIntoView({behavior: 'smooth'})
        }
      },
      changeCount(value) {
        if (this.count + value < 0) {
          return
        }
        this.count += value
      },
      changeWeightCount() {
        if (this.$store.getters.currentProduct.is_integer_weight_product) {
          this.weight = Math.round(Number(this.weight))
        }
        this.$emit('update:count', Number(this.weight))
      },
      getCategories() {
        let categories = []
        this.$store.getters.currentProduct.modifiers.forEach((element) => {
          if (
            categories.every((el) => {
              return el.id !== element.category_id
            })
          ) {
            let category = {
              id: element.category_id,
              name: element.category
            }
            category.is_radio_type = element.is_radio_type
            category.data = element.categoryNew
            category.conditions = element.conditions
            categories.push(category)
          }
        })
        return categories
      },
      getModifiers(category) {
        let result = []
        this.$store.getters.currentProduct.modifiers.forEach((element) => {
          if (element.category_id === category.id) {
            result.push(element)
          }
        })
        return result
      },
      isNeeded(category) {
        return this.needToSelect.some((el) => {
          return el.id === category.id
        })
      },
      inSelectedRule(category) {
        return this.selectRules.some((el) => {
          return el.show === true && el.category_id === category.id
        })
      },
      getSelectedRuleMessage(category) {
        let msg
        this.selectRules.forEach((el) => {
          if (el.category_id === category.id) {
            msg = el.message
          }
        })
        return msg
      },
      pick(type, element) {
        if (type === "radio") {
          if (element.images.length > 0 && this.$refs.slick) {
            const slickImgIndex =
              this.$store.getters.currentProduct.images.findIndex(
                (img) => element.images[0].id === img.id
              );
            if (slickImgIndex !== -1) {
              this.$refs.slick.goTo(slickImgIndex);
            }
          }
          // if clicked modifier doesn't exist in this.pickedModifiers
          if (
            !this.pickedModifiers.some((pickedElement) => {
              return (
                pickedElement.id === element.id &&
                pickedElement.category_id === element.category_id
              );
            })
          ) {
            let i = this.pickedModifiers.length;
            while (i--) {
              if (this.pickedModifiers[i].category_id === element.category_id) {
                this.pickedModifiers.splice(i, 1);
              }
            }
            this.pickedModifiers.push(element);
            if (element.categoryNew.style === "photo") {
              this.updateImage(element.image);
            }
          }
          this.rules.conditions.some((rule) => {
            if (rule.if.modifier_id === element.modifier_id) {
              const category = this.getCategories().find(
                (category) => category.id === rule.category_id
              );
              this.clearModifiers(category);
            }
          });
          if (
            !this.rules.conditions.some(
              (rule) => rule.if.modifier_id === element.modifier_id
            )
          ) {
            this.disabledElements = [];
          }
        }
        if (type === "checkbox") {
          if (
            !this.checkedModifiers.some((pickedElement) => {
              return (
                pickedElement.id === element.id &&
                pickedElement.category_id === element.category_id
              );
            })
          ) {
            if (
              this.blockedCategories.some((blockedCategory) => {
                return blockedCategory === element.category_id;
              })
            ) {
                //   return null;
            }
          }
          let currentRule;
          this.rules.current.forEach((rule) => {
            if (rule.category_id === element.category_id) {
              currentRule = rule;
            }
          });
          if (currentRule && currentRule.maxForModifier > 1) {
            if (
              this.checkedModifiers.some((pickedElement) => {
                return (
                  pickedElement.id === element.id &&
                  pickedElement.category_id === element.category_id
                );
              })
            ) {
              this.checkedModifiers.forEach((pickedElement, index) => {
                if (pickedElement.modifier_id === element.modifier_id) {
                  let tempCount = this.getModifierCount(
                    this.checkedModifiers[index].id
                  );
                  if (currentRule.maxForModifier > tempCount)
                    this.setModifierCount(
                      this.checkedModifiers[index].id,
                      tempCount + 1
                    );
                }
              });
            } else {
              let tempCount = this.getModifierCount(element.id);
              if (currentRule.maxForModifier > tempCount) {
                this.setModifierCount(element.id, tempCount + 1);
                this.checkedModifiers.push(element);
              }
            }
          } else {
            if (
              this.checkedModifiers.some((pickedElement) => {
                return (
                  pickedElement.id === element.id &&
                  pickedElement.category_id === element.category_id
                );
              })
            ) {
              let i = this.checkedModifiers.length;
              while (i--) {
                if (this.checkedModifiers[i].id === element.id) {
                  this.setModifierCount(element.id, 0);
                  this.checkedModifiers.splice(i, 1);
                }
              }
            } else {
              this.setModifierCount(element.id, 1);
              this.checkedModifiers.push(element);
            }
          }
        }
        this.processConditions(type);
      },
      unpickCheck(element) {
        let i = this.checkedModifiers.length;
        while (i--) {
          if (this.checkedModifiers[i].id === element.id) {

            this.setModifierCount(element.id, 0);
            this.modifiersCount.map(item => {
              if (item.modifier_id === element.id) {
                item.count = 0;
              }
            })

            this.checkedModifiers.splice(i, 1);
          }
        }
      },
      isPicked(type, element) {
        if (type === 'radio') {
          return this.pickedModifiers.some((pickedElement) => {
            return (
              pickedElement.id === element.id &&
              pickedElement.category_id === element.category_id
            )
          })
        }
        if (type === 'checkbox') {
          return this.checkedModifiers.some((pickedElement) => {
            return (
              pickedElement.id === element.id &&
              pickedElement.category_id === element.category_id
            )
          })
        }
      },
      updateCurrentRulesAccordingConditions() {
        let rules = JSON.parse(JSON.stringify(this.rules.default))
        this.rules.conditions.forEach((condition) => {
          this.pickedModifiers.forEach((pickedModifier) => {
            if (pickedModifier.modifier_id === condition.if.modifier_id) {
              rules.forEach((rule) => {
                if (condition.category_id === rule.category_id) {
                  rule.min = condition.min
                  rule.max = condition.max
                }
              })
            }
          })
        })
        this.$set(this.rules, 'current', rules)
      },
      updateModifiersAccordingToRules() {
        this.rules.current.forEach((rule) => {
          let count = 0
          let categoryModifiers = []
          this.$store.getters.currentProduct['modifiers'].forEach(
            (currentProductModifier) => {
              if (currentProductModifier.category_id === rule.category_id) {
                categoryModifiers.push(currentProductModifier)
              }
            }
          )
          if (rule.max !== null) {
            let i = this.checkedModifiers.length
            while (i--) {
              if (this.checkedModifiers[i].category_id === rule.category_id) {
                count = this.categoryModifiersCount.find(el => el.category_id === this.checkedModifiers[i].category_id).category_count
                if (count > rule.max) {
                  count -= this.getModifierCount(this.checkedModifiers[i].id)
                  if (this.getModifierCount(this.checkedModifiers[i].id)) {
                    this.setModifierCount(this.checkedModifiers[i].id, 0)
                  }
                  this.checkedModifiers.splice(i, 1)
                }
              }
            }
            if (rule.max === count) {
              categoryModifiers.forEach((categoryModifier) => {
                if (
                  !this.disabledElements.some((el) => {
                    return el === categoryModifier.id
                  })
                ) {
                  this.disabledElements.push(categoryModifier.id)
                }
                if (
                  !this.blockedCategories.some((el) => {
                    return el === categoryModifier.category_id
                  })
                ) {
                  this.blockedCategories.push(categoryModifier.category_id)
                }
              })
            } else {
              categoryModifiers.forEach((categoryModifier) => {
                let i = this.disabledElements.length
                while (i--) {
                  if (this.disabledElements[i] === categoryModifier.id) {
                    this.disabledElements.splice(i, 1)
                  }
                }
              })
              categoryModifiers.forEach((categoryModifier) => {
                let i = this.blockedCategories.length
                while (i--) {
                  if (
                    this.blockedCategories[i] === categoryModifier.category_id
                  ) {
                    this.blockedCategories.splice(i, 1)
                  }
                }
              })
            }
          }
          if (rule.min !== null) {
            if (count < rule.min) {
              let hasSelectedRule = false
              this.selectRules.forEach((selectRule) => {
                if (rule.category_id === selectRule.category_id) {
                  hasSelectedRule = true
                  selectRule.message = this.text('product_options_choose_more', {
                    amount: rule.min - count
                  })
                }
              })
              if (!hasSelectedRule) {
                this.selectRules.push({
                  show: false,
                  category_id: rule.category_id,
                  message: this.text('product_options_choose_more', {
                    amount: rule.min - count
                  })
                })
              }
            } else {
              let i = this.selectRules.length
              while (i--) {
                if (this.selectRules[i].category_id === rule.category_id) {
                  this.selectRules.splice(i, 1)
                }
              }
            }
          }
        })
      },
      processConditions(type) {
        if (type === 'radio') {
          this.updateCurrentRulesAccordingConditions()
          this.updateModifiersAccordingToRules()
        }
        if (type === 'checkbox') {
          this.updateModifiersAccordingToRules()
        }
      },
      clearModifiers(category) {
        let i = this.checkedModifiers.length
        while (i--) {
          if (this.checkedModifiers[i].category_id === category.id) {
            if (this.getModifierCount(this.checkedModifiers[i].id)) {
              this.setModifierCount(this.checkedModifiers[i].id, 0)
            }
            this.checkedModifiers.splice(i, 1)
          }
        }
        const modifiersRemoveId = []
        this.modifiersCount.forEach((modifier) => {
          if (modifier.category_id === category.id) {
            modifier.count = 0
            modifier.category_count = 0
            modifiersRemoveId.push(modifier.modifier_id)
          }
        })
        this.categoryModifiersCount.forEach((el) => {
          if (el.category_id === category.id) {
            el.category_count = 0
          }
        })
        modifiersRemoveId.forEach(el => {
          this.checkedModifiersId = this.checkedModifiersId.filter(id => el !== id)
        })
        this.updateModifiersAccordingToRules()
      },
      showClearModifiersButton(category) {
        if (category.data.max_qty_modifier <= 1) {
          return false
        }
        let count = 0
        this.getModifiers(category).forEach((modifier) => {
          count += this.getModifierCount(modifier.id)
        })
        return count > 0
      },
      setModifier(modifier_id, count) {
        this.modifiersCount.forEach((modifier) => {
          if (modifier.modifier_id === modifier_id) {
            modifier.count = Number(count)
          }
        })
      },
      setModifierCount(modifier_id, count) {
        let isDecrement = this.modifiersCount.find(el => el.modifier_id === modifier_id).count > count ? true : false;
        let categoryId;
        let categoryCount;
        this.modifiersCount.forEach((modifier) => {
          if (modifier.modifier_id === modifier_id) {
            if (count) {
              modifier.count = Number(count);
            }
            categoryId = modifier.category_id;
            this.checkedModifiersId.push(modifier_id);
            if (count === 0) {
              this.checkedModifiersId = this.checkedModifiersId.filter(
                (id) => id !== modifier_id
              );
            }
          }
        });
        this.modifiersCount.forEach((modifier) => {
          if (modifier.category_id === categoryId) {
            if (isDecrement) {
              modifier.category_count--;
            } else {
              modifier.category_count++;
            }
            categoryCount = modifier.category_count;
          }
        });
        if (
          this.categoryModifiersCount.some((el) => el.category_id === categoryId)
        ) {
          this.categoryModifiersCount.forEach((el) => {
            if (el.category_id === categoryId) {
              el.category_count = categoryCount;
            }
          });
        } else {
          this.categoryModifiersCount.push({
            category_id: categoryId,
            category_count: categoryCount,
          });
        }
      },
      getModifierCount(modifier_id, isFree) {
        let count = null
        this.modifiersCount.forEach((modifier) => {
          if (!isFree && (modifier.modifier_id === modifier_id)) {
            count = modifier.count
          } else if (isFree && (modifier.modifier_id === modifier_id)) {
            count = modifier.enable_max_modifiers_qty
          }
        })
        return count
      },
      isFreeModifier(modifier) {
        let count = null
        this.categoryModifiersCount.forEach((el) => {
          if (el.category_id === modifier.category_id) {
            count = el.category_count
          }
        })
        return this.getModifierCount(modifier.id, true) && (count < this.getModifierCount(modifier.id, true))
      },
      hasRule(category) {
        return this.rules.current.some((el) => {
          return el.category_id === category.id && (el.min || el.max)
        })
      },
      getRuleMessage(category) {
        let rule
        this.rules.current.forEach((el) => {
          if (el.category_id === category.id) {
            rule = el
          }
        })
        let message = this.text('product_options_choose')
        if (rule.min && rule.max) {
          message +=
            ' ' +
            this.text('product_options_from_to', {
              amount_from: rule.min,
              amount_to: rule.max
            }) +
            ' '
        } else {
          if (rule.min) {
            message += ' ' + this.text('product_options_from') + ' ' + rule.min
          }
          if (rule.max) {
            message += ' ' + this.text('product_options_to') + ' ' + rule.max
          }
        }
        return message
      },
      getImageUrl(image, type) {
        let params = ''
        if (type === this.IMAGE_TYPE_ORIGINAL) {
          return image.original + params
        }
        if (type === this.IMAGE_TYPE_SPLASH) {
          return image.splash + params
        }
        if (type === this.IMAGE_TYPE_SPLASH_2X) {
          return image.splash_2x + params
        }
        if (type === this.IMAGE_TYPE_LARGE) {
          return image.large + params
        }
      },
      removeModifier(modifier) {
        if (this.getModifierCount(modifier.id) <= 1) {
          this.pick("checkbox", modifier);
          return false;
        }

        this.checkedModifiers = this.checkedModifiers.map(item => {
          if (item.id === modifier.id && item.count > 0) {
            item.count--;
          }
          return item;
        })
        const index = this.checkedModifiersId.indexOf(modifier.id);
        if (index > -1) {
          // it just works, no idea why
          this.checkedModifiersId.splice(index, 1)
          this.checkedModifiersId.splice(index, 1);
        }
        this.setModifierCount(modifier.id, this.getModifierCount(modifier.id) - 1);
      },
    },
    computed: {
      isModalShown() {
        return this.$store.getters.currentProduct && this.$store.getters.modal.options
      },
      displayImage() {
        return this.modifierImage || this.$store.getters.currentProduct.images.length > 0
      },
      disableChangeCount() {
        const currentProduct = this.$store.getters.currentProduct
        const upsells = this.$store.getters.upsell
        const currentUpsell = upsells.find(el => el.id === currentProduct.id)
        if (currentUpsell && currentUpsell.disableQty && currentProduct.count >= currentUpsell.disableQty) {
          return 'disable'
        } else {
          return ''
        }
      },
      isRtl() {
        return this.$store.getters.guardCssDirection === 'rtl'
      },
      placeholderPadding() {
        let padding = '66.67%'
        if (
          this.imagesStyle === this.IMAGES_SQUARE_MINIATURE ||
          this.imagesStyle === this.IMAGES_SQUARE_LEFT ||
          this.imagesStyle === this.IMAGES_SQUARE_RIGHT
        ) {
          padding = '100%'
        }
        return padding
      },
      countPrice() {
        this.newSentCheckedModifiers = []
        let price = this.$store.getters.currentProduct.price
        this.pickedModifiers.forEach((picked) => {
          this.newSentCheckedModifiers.push({
            id: picked.id,
            is_free: 0
          })
          price += picked.price
        })
        this.selectedModifiers.forEach((selected) => {
          this.newSentCheckedModifiers.push({
            id: selected.id,
            is_free: 0
          })
          price += selected.price
        })
        const categoryModifiersCount = []
        this.checkedModifiersId.forEach((selected) => {
          const countFree = this.getModifierCount(selected, true)
          let categoryId = 0
          let localPrice = 0
          let categoryCount
          this.checkedModifiers.forEach(el => {
            if (el.id === selected) {
              categoryId = el.category_id
              localPrice = el.price
            }
          })
          if (categoryModifiersCount.some(el => el.category_id === categoryId)) {
            categoryModifiersCount.forEach(el => {
              if (el.category_id === categoryId) {
                el.category_count++
              }
            })
          } else {
            categoryModifiersCount.push({
              category_id: categoryId,
              category_count: 1
            })
          }
          categoryModifiersCount.forEach(el => {
            if (el.category_id === categoryId) {
              categoryCount = el.category_count
            }
          })
          if (categoryCount <= countFree) {
            this.newSentCheckedModifiers.push({
              id: selected,
              is_free: 1
            })
            return
          } else {
            this.newSentCheckedModifiers.push({
              id: selected,
              is_free: 0
            })
            price += localPrice
          }
        })
        if (price < 0) {
          price = 0
        }
        if (this.$store.getters.currentProduct.is_weight_product && this.$store.getters.currentProduct.enable_selection_qty) {
          return price * this.weight
        } else {
          return price * this.count
        }
      },
      addNew() {
        return this.$router.currentRoute.name !== 'receipt'
      },
      button() {
        if (!this.addNew && this.alreadySelected) {
          if ((this.count === 0 || this.$store.getters.currentProduct.is_weight_product && this.weight === '' || this.weight === 0)) {
            return this.text('product_remove')
          } else {
            return this.text('product_save')
          }
        } else {
          if ((this.count === 0 || this.$store.getters.currentProduct.is_weight_product && this.weight === '' || this.weight === 0) && this.$store.getters.currentProduct.enable_selection_qty) {
            return this.$store.getters.currentProduct.is_weight_product ? "Укажите количество" : this.text('clear_basket_cancel')
          } else {
            return this.text('product_add')
          }
        }
      },
      ...mapGetters([
        'basketPhoto',
        'imagesStyle',
        'IMAGES_SQUARE_MINIATURE',
        'IMAGES_SQUARE_LEFT',
        'IMAGES_SQUARE_RIGHT',
        'IMAGES_WIDE',
        'modal'
      ])
    },
    watch: {
      isModalShown: function (isShown) {
        this.$nextTick(() => {
          if (isShown && this.$refs.scrollContainer && this.$refs.productImage) {
            const scrollOffset = Math.round(this.$refs.productImage.clientHeight / 2)
            this.$refs.scrollContainer.scrollTo(0, scrollOffset) // до половины высоты изображения
          }
        })
      }
    },
  }
</script>

<style scoped>
  .pu_rule_msg {
    display: block;
    font-size: 12px;
  }
  .cart__count-up.disable {
    pointer-events: none;
    cursor: default;
  }
  .cart__count-up.disable svg path {
    fill: #ccc;
  }
  div.placeholder {
    width: 100%;
    height: 0;
    background: #f7f7f7;
    position: relative;
  }
  img.placeholded-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  /*.multiple-images::after {*/
  /*    content: '';*/
  /*    display: block;*/
  /*    position: absolute;*/
  /*    left: 0;*/
  /*    top: 0;*/
  /*    width: 100%;*/
  /*    height: 100%;*/
  /*    background: linear-gradient(rgba(0, 0, 0, 0.5) 0%, transparent 10%);*/
  /*}*/
  .changeCountBox {
    min-width: 18px;
    min-height: 18px;
    width: 18px;
    height: 18px;
    top: 11px;
    left: 2px;
    border-radius: 3px;
    border: 2px solid #0084ff;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    margin-right: 10px;
  }
  .changeCountBox.increment {
    margin-left: 10px;
  }
  .changeCountBox svg {
    max-width: 100%;
    max-height: 100%;
  }
  .modifier {
    margin-top: 12px;
  }

  .modifier-range {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    box-sizing: border-box;
    padding-left: 2px;

    padding-top: 11px;
    padding-bottom: 10px;
  }

  .rtlStyle .changeCountBox {
    margin-right: 0px;
    margin-left: 10px;
  }

  .rtlStyle .changeCountBox.increment {
    margin-right: 10px;
    margin-left: 10px;
  }

  span.nowrap {
    white-space: nowrap;
  }

  span.modifier-name-divider {
    margin-right: 10px;
  }
</style>

<style>
  .product-slider .slick-slide {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 5px;
  }
</style>
